import { createContext, useContext, useState, type FunctionComponent, type ReactNode } from "react";

interface BackgroundTasksContextType {
  isDrawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
  showCompleted: boolean;
  setShowCompleted: (value: boolean) => void;
}

const BackgroundTasksContext = createContext<BackgroundTasksContextType | undefined>(undefined);

interface BackgroundTasksProviderProps {
  children: ReactNode;
}

export const BackgroundTasksProvider: FunctionComponent<BackgroundTasksProviderProps> = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);

  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  const toggleDrawer = () => setIsDrawerOpen((prev) => !prev);

  const value: BackgroundTasksContextType = {
    isDrawerOpen,
    openDrawer,
    closeDrawer,
    toggleDrawer,
    showCompleted,
    setShowCompleted,
  };

  return <BackgroundTasksContext.Provider value={value}>{children}</BackgroundTasksContext.Provider>;
};

export const useBackgroundTasks = (): BackgroundTasksContextType => {
  const context = useContext(BackgroundTasksContext);
  if (context === undefined) {
    throw new Error("useBackgroundTasks must be used within a BackgroundTasksProvider");
  }
  return context;
};
